import { normalizeGroupIds } from '../groups';
import { useAuthContext } from './use-auth-context';

// ----------------------------------------------------------------------

type UseUserGroupsResult = {
  /** Group-IDs, denen der aktuelle User zugeordnet ist (immer normalisiert). */
  groups: string[];
  loading: boolean;
};

/**
 * Liefert die Gruppen-Zuordnung des aktuell angemeldeten Users.
 * Unabhängig von der Rolle (siehe `useUserRole`).
 */
export function useUserGroups(): UseUserGroupsResult {
  const { user, loading } = useAuthContext();

  if (loading) {
    return { groups: [], loading: true };
  }

  if (!user) {
    return { groups: [], loading: false };
  }

  const raw = (user as { groups?: unknown }).groups;
  return { groups: normalizeGroupIds(raw), loading: false };
}
